import {UpdateQueryStrategyFactory} from './query-update.strategy';
import {FrontendUmsatzstatistikQuery} from '../types/frontend-umsatzstatistik.query';

export const lagerplatzQueryUpdateStrategy: UpdateQueryStrategyFactory<string> = () => {
  return {
    umsatzebene: 'Lagerplatz',
    updateFn: async (key, query) => {
      query.lagerplatz = { lagerplatz: key } as any;
      return query;
    },
    removeFn: async (query: FrontendUmsatzstatistikQuery)  => {
      delete query['lagerplatz']
      return query;
    }
  }
}
